import styled from 'styled-components';

const FlexContainer = styled.div`
  @media (min-width: 1024px) {
    display: flex;
  }
`;

const Form = styled.form`
  margin-top: 20px;
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: 1024px) {
    grid-gap: 20px;
    grid-template-columns: 1fr 1fr;
  }
`;

const LabelInput = styled.label`
  position: absolute;
  top: -6px;
  font-size: 12px;
  color: #bdbdbd;
  z-index: 2;
  background: #ffffff;
  left: 16px;
  padding: 0px 4px;
  font-weight: 600;

  &:first-letter {
    text-transform: uppercase;
  }

  @media (min-width: 1024px) {
    font-size: 15px;
  }
`;

const InputContainer = styled.div`
  position: relative;
  margin-bottom: 28px;

  span {
    color: #212121;
    font-size: 12px;
  }

  @media (min-width: 1024px) {
    margin-bottom: 30px;
  }
`;

const LeftContainer = styled.div`
  @media (min-width: 1024px) {
    flex-grow: 2;
    margin-right: 64px;
  }
`;

const RightContainer = styled.div`
  @media (min-width: 1024px) {
    flex-grow: 1;
  }
`;

const Button = styled.button`
  display: flex;
  justify-content: center;
  font-size: 15px;
  color: #ffffff;
  border: none;
  background-color: ${props => props.color || '#009688'};
  padding: 14px 0;
  font-weight: 600;
  border-radius: 8px;
  width: 100%;
  max-width: 230px;
  position: relative;
  margin-bottom: 10px;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;

  &:active {
    transform: translateY(10px);
  }

  .loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 20px;
    display: grid;
    place-content: center;
    background-color: white;
  }

  &:disabled {
    background-color: #f4f4f4;
    color: #707070;
    cursor: not-allowed;
    transform: none;
  }
`;

export {
  Form,
  FormRow,
  LabelInput,
  InputContainer,
  FlexContainer,
  LeftContainer,
  RightContainer,
  Button,
};
